import React from 'react'
import { Row, Col, Divider } from 'antd';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faTerminal from '@fortawesome/fontawesome-free-solid/faTerminal'
import {
  faReact,
  faAngular,
  faNode,
  faCss3Alt,
  faHtml5,
  faGit,
  faJs,
  faPhp,
  faLaravel,
  faStackOverflow
} from '@fortawesome/fontawesome-free-brands'

const Skills = ({

}) => {
    return (
      <div className="container white-text">
        <h3 className="skills"> <FontAwesomeIcon icon={faTerminal} /> SKILLS </h3>
        <Divider />
        <Row type="flex" justify="space-around" align="top" className="mt-5">
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faReact} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faAngular} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faNode} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faHtml5} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faJs} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faCss3Alt} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faPhp} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faLaravel} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faGit} size="5x" />
          </Col>
          <Col sm={1} md={3} className="mx-2 my-4">
            <FontAwesomeIcon icon={faStackOverflow} size="5x" />
          </Col>
        </Row>
      </div>
    );
}

export default Skills


// WEBPACK FOOTER //
// ./src/components/Skills.js